export default __webpack_public_path__ + "static/media/wa_white.970ccec8.svg";